import axios from 'axios'

export function createCommonActions(state) {
    function showNotification(payload) {
        setTimeout(() => {
            state.notification.show = true
            state.notification.type = payload.type
            state.notification.message = payload.message
            state.notification.action = payload.action
            state.notification.timeout = typeof payload.timeout === 'undefined' ? 5000 : payload.timeout
        }, 250)
    }

    function hideNotification() {
        state.notification.show = false
        // Reset notification state after animation completes
        setTimeout(() => {
            state.notification.type = ''
            state.notification.message = ''
            state.notification.action = null
            state.notification.timeout = -1
        }, 300)
    }

    function toggleMainLoader(value) {
        state.mainLoader.value = value
    }

    function toggleCircularLoader(value) {
        state.circularLoader.value = value
    }

    function setAppUpdateState(value) {
        state.updated.value = value
    }

    async function getErrorCodes() {
        try {
            const response = await axios.get('/globals/dicts/error-codes')
            state.errorCodes.value = response.data.results
            return response.data
        } catch (error) {
            console.error('Failed to fetch error codes:', error)
            return []
        }
    }

    function savePagination({ moduleName, pagination, filters, nextUrl, prevUrl, settings }) {
        if (!state.savedPagination[moduleName]) {
            state.savedPagination[moduleName] = {}
        }
        state.savedPagination[moduleName] = {
            pagination: { ...pagination },
            filters: filters ? { ...filters } : {},
            nextUrl: nextUrl || null,
            prevUrl: prevUrl || null,
            settings: settings ? { ...settings } : {}
        }
    }

    function clearPagination(moduleName = null) {
        if (moduleName && state.savedPagination[moduleName]) {
            delete state.savedPagination[moduleName]
        } else {
            Object.keys(state.savedPagination).forEach((key) => {
                delete state.savedPagination[key]
            })
        }
    }

    function getSavedPagination(moduleName) {
        return state.savedPagination[moduleName] || null
    }

    function setSelectedListItemId(id) {
        state.selectedListItemId.value = id
    }

    function clearSelectedListItemId() {
        state.selectedListItemId.value = null
    }

    function setDeviceCameras(cameras) {
        state.hasCamera.value = Array.isArray(cameras) && cameras.length > 0
    }

    return {
        showNotification,
        hideNotification,
        toggleMainLoader,
        toggleCircularLoader,
        setAppUpdateState,
        getErrorCodes,
        setDeviceCameras,
        savePagination,
        clearPagination,
        getSavedPagination,
        setSelectedListItemId,
        clearSelectedListItemId
    }
}
